(async function initFslFilter() {
    const fslElements = document.getElementsByClassName("fsl-root");
    if (!fslElements || fslElements.length === 0) return;

    // Dynamically import SlimSelect & styles only when .fsl-root elements are present
    let SlimSelect;
    try {
        const slimSelectModule = await import("slim-select");
        await import("slim-select/styles");
        SlimSelect = slimSelectModule.default || slimSelectModule;
    } catch (err) {
        console.error("Failed to dynamically load SlimSelect:", err);
    }

    const baseTitle = document.title;
    const baseUrl = window.location.href.split("?")[0];

    // Global tag and category collections using Set for automatic uniqueness
    const allTagsSet = new Set();
    const allCategoriesSet = new Set();

    // Map to store SlimSelect instances per element for clean teardown/updates
    const slimSelectInstances = new Map();

    function populateSelectOptions(fslElement) {
        const filterTagSelect = fslElement.querySelector(".filter .tag select");
        const filterCategorySelect = fslElement.querySelector(".filter .category select");

        filterTagSelect?.querySelectorAll("option").forEach(opt => {
            if (opt.value) allTagsSet.add(opt.value);
        });

        filterCategorySelect?.querySelectorAll("option").forEach(opt => {
            if (opt.value) allCategoriesSet.add(opt.value);
        });

        if (allTagsSet.size === 0 && filterTagSelect) {
            filterTagSelect.closest(".tag")?.style.setProperty("display", "none");
        }
        if (allCategoriesSet.size === 0 && filterCategorySelect) {
            filterCategorySelect.closest(".category")?.style.setProperty("display", "none");
        }
    }

    function clearSelections(fslElement) {
        const filterTagSelect = fslElement.querySelector(".filter .tag select");
        const filterCategorySelect = fslElement.querySelector(".filter .category select");

        if (filterTagSelect) filterTagSelect.value = "";
        if (filterCategorySelect) filterCategorySelect.value = "";

        // Reset SlimSelect UI if initialized
        if (filterTagSelect && slimSelectInstances.has(filterTagSelect)) {
            slimSelectInstances.get(filterTagSelect).setSelected([]);
        }
    }

    function addChangeEvents(fslElement) {
        const filterTagSelect = fslElement.querySelector(".filter .tag select");
        const filterCategorySelect = fslElement.querySelector(".filter .category select");
        const clearBtn = fslElement.querySelector(".filter .clear");

        filterTagSelect?.addEventListener("change", () => populateResults(fslElement));
        filterCategorySelect?.addEventListener("change", () => populateResults(fslElement));

        clearBtn?.addEventListener("click", () => {
            clearSelections(fslElement);
            populateResults(fslElement);
        });
    }

    function updateSelectors(fslElement) {
        fslElement.dataset.populate = "false";

        const filterTagSelect = fslElement.querySelector(".filter .tag select");
        const filterCategorySelect = fslElement.querySelector(".filter .category select");
        const currentCatValue = filterCategorySelect?.value || "";
        const currentTagValue = filterTagSelect?.value || "";

        const allCategories = Array.from(allCategoriesSet).sort((a, b) => a.localeCompare(b));
        const allTags = Array.from(allTagsSet).sort((a, b) => a.localeCompare(b));

        // Update Categories
        if (filterCategorySelect) {
            filterCategorySelect.innerHTML = "<option value=''>All</option>";
            let cats = [];

            if (currentTagValue) {
                fslElement.querySelectorAll(".fsl-item").forEach(item => {
                    const itemTags = item.dataset.tags ? JSON.parse(item.dataset.tags) : [];
                    const itemCategory = item.dataset.category;
                    if (itemTags.includes(currentTagValue) && itemCategory && !cats.includes(itemCategory)) {
                        cats.push(itemCategory);
                    }
                });
                cats.sort((a, b) => a.localeCompare(b));
            } else {
                cats = allCategories;
            }

            cats.forEach(cat => {
                const option = document.createElement("option");
                option.value = cat;
                option.text = cat;
                option.selected = cat === currentCatValue;
                filterCategorySelect.appendChild(option);
            });
        }

        // Update Tags
        if (filterTagSelect) {
            filterTagSelect.innerHTML = "<option value=''>Any</option>";
            let tags = [];

            if (filterCategorySelect?.value) {
                fslElement.querySelectorAll(".fsl-item").forEach(item => {
                    const itemTags = item.dataset.tags ? JSON.parse(item.dataset.tags) : [];
                    const itemCategory = item.dataset.category;
                    if (itemCategory === filterCategorySelect.value) {
                        itemTags.forEach(tag => {
                            if (tag && !tags.includes(tag)) tags.push(tag);
                        });
                    }
                });
                tags.sort((a, b) => a.localeCompare(b));
            } else {
                tags = allTags;
            }

            tags.forEach(tag => {
                const option = document.createElement("option");
                option.value = tag;
                option.text = tag;
                option.selected = tag === currentTagValue;
                filterTagSelect.appendChild(option);
            });
        }

        fslElement.dataset.populate = "true";
    }

    function setSelectedFromUrl(fslElement) {
        const searchParams = new URLSearchParams(window.location.search);
        const filterTagValues = searchParams.getAll("tag");
        const filterCategoryValue = searchParams.get("category");

        if (filterTagValues.length > 0) {
            const filterTagSelect = fslElement.querySelector(".filter .tag select");
            filterTagSelect?.querySelectorAll("option").forEach(option => {
                if (filterTagValues.includes(option.value)) {
                    option.selected = true;
                }
            });
        }

        if (filterCategoryValue && fslElement) {
            const catSelect = fslElement.querySelector(".filter .category select");
            if (catSelect) {
                catSelect.value = filterCategoryValue;
            }
        }
    }

    function getUrlQueryString(fslElement) {
        const filterTagSelect = fslElement.querySelector(".filter .tag select");
        const tags = filterTagSelect ? Array.from(filterTagSelect.selectedOptions).map(opt => opt.value).filter(Boolean) : [];

        const tagsQuery = tags.map(tag => `&tag=${encodeURIComponent(tag)}`).join("");

        const filterCategorySelect = fslElement.querySelector(".filter .category select");
        const filterCategoryValue = filterCategorySelect?.value || "";
        const catQuery = filterCategoryValue ? `&category=${encodeURIComponent(filterCategoryValue)}` : "";

        const query = `${tagsQuery}${catQuery}`;
        return query ? `?${query.substring(1)}` : "";
    }

    function setUrl(fslElement, id) {
        let url = `${baseUrl}${getUrlQueryString(fslElement)}`;
        if (id) {
            url += `${url.includes('?') ? '&' : '?'}id=${encodeURIComponent(id)}`;
        } else {
            document.title = baseTitle;
        }
        history.pushState(null, baseTitle, url);
    }

    function populateResults(fslElement, doNotSetUrl = false) {
        if (fslElement.dataset.populate === "true") {
            if (!doNotSetUrl) {
                setUrl(fslElement);
            }

            const cat = fslElement.querySelector(".filter .category select")?.value;
            const tagSelect = fslElement.querySelector(".filter .tag select");
            const tags = tagSelect ? Array.from(tagSelect.selectedOptions).map(opt => opt.value).filter(Boolean) : [];

            fslElement.querySelectorAll(".fsl-item").forEach(item => {
                const itemTags = item.dataset.tags ? JSON.parse(item.dataset.tags) : [];
                const itemCategory = item.dataset.category;

                const matchesCategory = !cat || itemCategory === cat;
                const matchesTags = tags.length === 0 || tags.some(tag => itemTags.includes(tag));

                if (matchesCategory && matchesTags) {
                    item.classList.remove("hide");
                } else {
                    item.classList.add("hide");
                }
            });

            updateSelectors(fslElement);
        }
    }

    // Initialize all root elements
    for (const fslElement of fslElements) {
        const selectElement = fslElement.querySelector(".tag select");

        if (selectElement && SlimSelect) {
            const ssInstance = new SlimSelect({ select: selectElement });
            slimSelectInstances.set(selectElement, ssInstance);
        }

        fslElement.dataset.populate = "true";
        populateSelectOptions(fslElement);
        setSelectedFromUrl(fslElement);
        addChangeEvents(fslElement);
        populateResults(fslElement, true);
    }
})();